import { userProfileApi } from "@/core/apis";

// getter types
export const USER_PFORILE = "userProfile";

// action types
export const GET_USER_PROFILE = "getUserProfile";

// mutation types
const SET_USER_PROFILE = "setUserProfile";

const state = {
  userProfile: {
    greenTime: 0,
    yellowTime: 0,
    orangeTime: 0,
    redTime: 0
  }
};

const getters = {
  [USER_PFORILE](state) {
    return state.userProfile;
  }
};

const actions = {
  [GET_USER_PROFILE](context) {
    return new Promise(resolve => {
      userProfileApi.getUserProfile().then(response => {
        context.commit(SET_USER_PROFILE, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_USER_PROFILE](state, userProfiles) {
    state.userProfile.greenTime = +userProfiles.find(c => c.profileKey === 5)
      .value;

    state.userProfile.yellowTime = +userProfiles.find(c => c.profileKey === 6)
      .value;

    state.userProfile.orangeTime = +userProfiles.find(c => c.profileKey === 7)
      .value;

    state.userProfile.redTime = +userProfiles.find(c => c.profileKey === 8)
      .value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
